import React, { useState, useEffect } from "react";

const StarRating = ({ rating, onClick }) => {
  const stars = Array.from({ length: 5 }, (_, index) => (
    <span
      key={index}
      className={index < rating ? "star active" : "star"}
      onClick={() => onClick(index + 1)}
    >
      &#9733;
    </span>
  ));

  return <div className="star-rating">{stars}</div>;
};

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [newReview, setNewReview] = useState({
    rating: 0,
    comment: ""
  });

  useEffect(() => {
    fetch("https://flask-api-dlzd.onrender.com/reviews")
      .then((response) => response.json())
      .then((data) => setReviews(data));
  }, []);

  const reviewList = reviews.map((review, index) => (
    <div className="review" key={index}>
      <StarRating rating={review.rating} />
      <p className="comment">Comment: {review.comment}</p>
    </div>
  ));

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewReview((prevReview) => ({ ...prevReview, [name]: value }));
  };

  const handleRatingChange = (rating) => {
    setNewReview((prevReview) => ({ ...prevReview, rating }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Send POST request to server with new review data
    fetch("https://flask-api-dlzd.onrender.com/reviews", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(newReview)
    })
      .then((response) => response.json())
      .then((data) => {
        // Update reviews state with the newly added review
        setReviews((prevReviews) => [...prevReviews, data]);
        // Reset the new review form
        setNewReview({ rating: 0, comment: "" });
      });
  };

  return (
    <div className="reviews-section">
      <h1 className="title">Hello and Welcome to the Review Section</h1>
      <div className="reviews-container">{reviewList}</div>

      <form className="review-form" onSubmit={handleSubmit}>
        <label htmlFor="rating">Rating:</label>
        <StarRating rating={newReview.rating} onClick={handleRatingChange} />

        <label htmlFor="comment">Comment:</label>
        <textarea
          id="comment"
          name="comment"
          rows="4"
          value={newReview.comment}
          onChange={handleInputChange}
        ></textarea>

        <button type="submit">Submit Review</button>
      </form>
    </div>
  );
}
